import NationalIdInput from './NationalIdInput'

export default NationalIdInput